<template>
  <div>
    <!-- 搜索表单 -->
    <el-form :model="params" label-width="77px" class="ele-form-search" @keyup.enter.native="searchChart" @submit.native.prevent>
      <el-row :gutter="15">
        <el-col :md="6" :sm="12">
          <el-form-item label="日期:">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="handleDateChange"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="3" :sm="12">
          <el-form-item label="学部:">
            <el-select v-model="params.branchId" placeholder="请选择学部" style="width: 140px" @change="handleChange($event, 2)" clearable>
              <el-option v-for="item in branchList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="3" :sm="12">
          <el-form-item label="年级:">
            <el-select v-model="params.id" placeholder="请选择年级" style="width: 140px" @change="$forceUpdate()" clearable>
              <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="4">
          <el-form-item label="项目:" prop="accessProjectId">
            <el-select v-model="params.accessProjectId" placeholder="请选择项目" @change="$forceUpdate()" class="ele-block" clearable>
              <el-option v-for="item in projectList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="4" :sm="12">
          <div class="ele-form-actions">
            <el-button type="primary" @click="searchChart" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
            <el-button type="primary" @click="exportData" icon="el-icon-download" class="ele-btn-icon">导出</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="analysis-chart-card-content">
      <ele-chart ref='charts' :option="option2" style="height: 500px" />
    </div>
  </div>
</template>

<script>
  import EleChart from '@/components/EleChart';
  import { accessStatisticsChart, accessStatisticsChartExport, selectionList } from '@/config/fengyi/examine';
  export default {
    name: 'GradeItem',
    components: { EleChart },
    data() {
      return {
        params: {
          startDay: '',
          endDay: '',
          id: undefined,
          type: 3,
          branchId: undefined,
          accessProjectId: undefined,
        },
        date: null,
        branchList: [],
        gradeList: [],
        projectList: [],
        xAxisData: [],
        chartData: [],
      };
    },
    computed: {
      option2() {
        return {
          tooltip: {
            trigger: 'item',
          },
          xAxis: {
            type: 'category',
            data: this.xAxisData,
          },
          yAxis: {
            name: '分数',
            type: 'value',
          },
          series: {
            type: 'bar',
            data: this.chartData,
          },
        };
      },
    },
    created() {
      this.searchListbyType(1);
      this.searchListbyType(6);
    },
    methods: {
      // 搜索下拉选
      searchListbyType(type, id) {
        let data = {
          type: type,
          id: id,
        };
        selectionList(data).then((res) => {
          if (res.data.resCode == 200) {
            if (type == 1) {
              //校部
              this.branchList = res.data.data;
            } else if (type == 2) {
              //年级
              this.gradeList = res.data.data;
            } else if (type == 6) {
              this.projectList = res.data.data;
            }
          }
        });
      },
      // 搜索下拉框值变化
      handleChange(value, type) {
        if (type == 2) {
          this.gradeList = [];
          this.params.id = undefined;
        }
        this.searchListbyType(type, value);
      },
      handleDateChange(value) {
        this.params.startDay = value[0];
        this.params.endDay = value[1];
      },
      // 查询数据
      searchChart() {
        if (!this.params.id) return this.$message.error('请选择到年级');
        if (!this.params.accessProjectId) return this.$message.error('请选择项目');
        accessStatisticsChart(this.params).then((res) => {
          if (res.data.resCode == 200) {
            this.chartData = res.data.data.map((item) => item.value);
            this.xAxisData = res.data.data.map((item) => item.name);
            this.$refs.charts.init()
            this.$refs.charts.resize()
          }
        });
      },
      // 导出数据
      exportData() {
        accessStatisticsChartExport(this.params).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
    },
  };
</script>

<style scoped></style>
